import React from "react";
import styles from "./GradientIcon.module.scss";

interface GradientIconProps {
  path: string;
  viewBox: string;
  className?: string;
}

export const GradientIcon: React.FC<GradientIconProps> = ({
  path,
  viewBox,
  className,
}) => {
  const encodedPath = encodeURIComponent(
    `<svg viewBox="${viewBox}" xmlns="http://www.w3.org/2000/svg"><path d="${path}"/></svg>`,
  );
  const maskUrl = `url("data:image/svg+xml,${encodedPath}")`;

  return (
    <div
      className={`${styles["gradient-icon"]} ${className || ""}`}
      style={{
        maskImage: maskUrl,
        WebkitMaskImage: maskUrl,
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
};
